<template>
  <div class="invoice-wrap">
    <v-card class="light-card">
      <v-toolbar color="primary" id="toolbar">
        <v-card-title class="top-title">Invoice</v-card-title>
      </v-toolbar>
      <div class="card-body invoice-box" v-if="invoices">
        <v-list two-lines>
          <v-list-item
                  v-for="item in invoices"
                  :key="item.id"
          >
            <v-list-item-content>
              <v-list-item-title v-text="epochToDate(item.status_transitions.finalized_at)"></v-list-item-title>
              <v-list-item-subtitle v-html="getInvoiceSubtitle(item)"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="item.invoice_pdf">
              <a :href="item.invoice_pdf" download>
                <v-icon color="'grey'">save_alt</v-icon>
              </a>
            </v-list-item-action>

          </v-list-item>
        </v-list>
      </div>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'invoice',
  props: ['invoices'],
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['currentOrganization'])
  },
  methods: {
    getInvoiceSubtitle (item) {
      const dollars = item.amount_paid / 100
      return 'Amount: ' + dollars.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) + ', Status: ' + item.status
    },
    epochToDate (epoch) {
      try {
        const d = new Date(epoch * 1000)
        const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: '2-digit' })
        const [{ value: month },, { value: day },, { value: year }] = dateTimeFormat.formatToParts(d)

        return `${month} ${day}, ${year}`
      } catch (err) {
        return ''
      }
    }
  }
}
</script>
<style scoped lang="scss">
  ::v-deep {
    .card-body {
      padding: 10px;
      .v-list {
        .v-list-item {
          border-bottom: 1px solid #f1f1f1;
          .v-list-item__action {
            .theme--light.v-icon {
              color: #000;
              &:after {
                display: none;
              }
            }
          }
        }
      }
    }
  }
  .invoice-box {
    height: 350px;
    overflow-y: auto;
  }
</style>
